import React, {  Component } from "react";
import { Modal } from "react-bootstrap";

class TeachAndCertModal extends Component {

	constructor() {
		super();

		this.state = {
			other: "",
			selected: "",
		}

	}

	handleChange = (e, cert) => {

		let selected = e.target.checked ? cert : "";

		this.setState({ selected: selected })

	}

	hide = () => {

		const { onHide } = this.props;

		this.setState({ other: "", selected: "" });

		onHide();

	}

	save = () => {

		const { onHide, onSave } = this.props;
		const { other, selected } = this.state;

		onSave( selected === "cert" ? other : selected );

		this.setState({ other: "", selected: "" });

		onHide();

	}

	render() {

		const { other, selected } = this.state;

		const { isOpen, onHide, certificates } = this.props;

		return (
			<div>
				<Modal
					centered
					size="lg"
					show={isOpen}
					onHide={onHide}
					className="TeachAndCertf-modal"
				>
					<Modal.Header>
						<Modal.Title>Select your earned certificates and qualification</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<h5>Education, doctoral degree or other earned certificate</h5>
						{ certificates.map((cert, id) => (
							<div key={id}>
								<div className="checkBoxContainers">
									<label className="container" htmlFor={`defaultUnchecked${id}`}>
										{cert}
										<input
											type="checkbox" 
											id={`defaultUnchecked${id}`}
											checked={ selected === cert ? true : false }
											onChange={ (e) => this.handleChange( e, cert ) }
										/>
										<span className="checkmark"></span>
									</label>
								</div>
							</div>
						))}
						<div>
							<div className="checkBoxContainers">
								<label className="container" htmlFor="defaultUncheckedOther">
									Other earned certificate or qualification
									<input 
										type="checkbox" 
										id="defaultUncheckedOther"
										checked={ selected === "cert" ? true : false }
										onChange={ (e) => this.handleChange( e, "cert" ) }
									/>
									<span className="checkmark"></span>
								</label>
							</div>
						</div>
						{
							selected === "cert" ? (
								<input
									type="text"
									value={ other }
									className="form-control"
									placeholder="Type qualification"
									onChange={ (e) => this.setState({ other: e.target.value }) }
								/>
							) : ""
						}
					</Modal.Body>
					<Modal.Footer>
						<button className="cancel" onClick={this.hide}>Cancel</button>
						<button
							className="save"
							onClick={this.save}
							disabled={ !selected || ( selected === "cert" && !other ) ? true : false }
						>
							Save
						</button>
					</Modal.Footer>
				</Modal>
			</div>
		);
	}

}

export default TeachAndCertModal;
